import Node from '../node.js';

export default class NodeSubnetInputs extends Node
{
	constructor(pParent)
	{
		super(pParent);	
		this.setTakeInputResultsFromParent(true);
	}
	
	getType()
	{
		return 'subnetInputs';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		return null;
	}
}